<template lang="html">
  <div class="fill-height">
    <v-app-bar app flat color="white" height="72">
      <v-container class="px-0">
        <v-row>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
            <div class="d-flex align-center">
              <template v-if="$store.state.selected_outlet">
                <div class="store-name-text">
                  {{ $store.state.selected_outlet.name }}
                </div>
              </template>
              <v-spacer />
              <div class="d-flex align-center">
                <div class="wrap-table">
                  <div class="wrap-table-icon">
                    <img :src="icon_table" :alt="$t('table')">
                  </div>
                  <div class="wrap-table-content">
                    <div class="wrap-table-text">
                      {{ $t('table') }} {{ noTable }}
                    </div>
                  </div>
                </div>
                <div>
                  <locale />
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <div class="banner-splash" :style="{ backgroundImage: 'url(' + image + ')', height: 'calc(44% - 72px)' }" />
    <div class="container-banner-splash">
      <div class="logo-banner-splash">
        <template v-if="$store.state.selected_outlet">
          <img :src="$store.state.selected_outlet.logo" :alt="$store.state.selected_outlet.name" class="img-banner-splash">
        </template>
      </div>
    </div>
    <v-container>
      <v-row>
        <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
          <div class="text-center">
            <div class="title-splash">
              {{ $t('v2.welcome') }}
            </div>
            <div class="mt-1 subtitle-splash">
              {{ $t('v2.come_find_the_best_menu') }}
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <div ref="refMenuBottom" class="fixed-bottom">
      <v-container>
        <v-row>
          <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="py-0">
            <div class="olsera-brand mb-6 text-center">
              <div class="font-12 ol-grey-content font-weight-400" style="margin-bottom: 6px;">
                powered by
              </div>
              <div>
                <a href="https://www.olsera.com/id/online" target="_blank" rel="noopener noreferrer">
                  <img src="@/assets/images/olsera_logo.png" alt="Olsera.com" width="76">
                </a>
              </div>
            </div>
            <v-btn block color="v2_primary" height="40" class="br-5 text-none white--text font-16 font-weight-bold btn-v2-shadow" @click="goToMenu()">
              {{ $t('v2.menu') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>
<script>
import Locale from '@/components/v2/Locale'
export default {
  components: {
    Locale
  },
  data() {
    return {
      image: require('@/assets/images/v2/img/background_banner.png'),
      icon_table: require('@/assets/images/v2/img/icon_table.png'),
      outlets: [],
      margin_menu_bottom: 0,
      form: {
        remark: ''
      },
      params_outlet: {
        origin_lat: 0,
        origin_lon: 0
      },
      allow_location: false,
      store_id: '',
      cart: {},
      detail_table: {}
    }
  },
  computed: {
    noTable() {
      if (!this.$isEmpty(this.detail_table) && !this.$isEmpty(this.detail_table.table_detail) && this.detail_table.table_detail.name) {
        return this.detail_table.table_detail.name
      } else {
        return ''
      }
    },
    marginMenuBottom() {
      return this.margin_menu_bottom
    }
  },
  mounted() {
    this.margin_menu_bottom = this.$refs.refMenuBottom.clientHeight
    const LOCAL_DATA_CART = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_cart')
    if (LOCAL_DATA_CART) {
      this.cart = JSON.parse(LOCAL_DATA_CART)
    }
    const DETAIL_TABLE = localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_v2_table')
    if (DETAIL_TABLE) {
      this.detail_table = JSON.parse(DETAIL_TABLE)
    }
  },
  methods: {
    goToMenu() {
      this.$router.push({ name: '_menu' }).catch(() => {})
    }
  }
}
</script>
